import { FormEvent, useState } from "react";

const email = "a90189829@gmail.com";
const apiOrigin = process.env.NODE_ENV === "production" ? "" : `http://localhost:${process.env.REACT_APP_SERVER_PORT || "8000"}`;

export default function ContactMe() {
  const [name, setName] = useState("");
  const [sender, setSender] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (busy) return;
    setBusy(true); setNotice(""); setError("");
    try {
      const response = await fetch(`${apiOrigin}/apis/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: name.trim(), sender: sender.trim(), subject: subject.trim(), message: message.trim() }),
      });
      const result = await response.json().catch(() => null);
      if (!response.ok) throw new Error(result?.message || "문의를 보내지 못했습니다. 잠시 후 다시 시도해 주세요.");
      setName(""); setSender(""); setSubject(""); setMessage("");
      setNotice("문의가 전송되었습니다.");
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "문의를 보내지 못했습니다. 잠시 후 다시 시도해 주세요.");
    } finally { setBusy(false); }
  }

  return <div className="contact-me"><div><span className="eyebrow">CONTACT ME</span><h3>문의 남기기</h3><p>문의 내용과 회신받을 이메일을 입력해 주세요.</p><a className="inline-link" href={`mailto:${email}`}>{email} ↗</a></div><form onSubmit={submit}>
    <label htmlFor="contact-name">이름</label><input id="contact-name" value={name} onChange={event => setName(event.target.value)} maxLength={80} required />
    <label htmlFor="contact-email">회신 이메일</label><input id="contact-email" type="email" value={sender} onChange={event => setSender(event.target.value)} maxLength={120} required />
    <label htmlFor="contact-subject">제목</label><input id="contact-subject" value={subject} onChange={event => setSubject(event.target.value)} maxLength={120} required />
    <label htmlFor="contact-message">내용</label><textarea id="contact-message" value={message} onChange={event => setMessage(event.target.value)} maxLength={2000} rows={5} required />
    {error && <p className="form-error" role="alert">{error}</p>}{notice && <p className="form-notice" role="status">{notice}</p>}
    <button className="button primary" type="submit" disabled={busy}>{busy ? "전송 중…" : "문의 보내기 ↗"}</button>
  </form></div>;
}
